import { Component } from '@angular/core';
import { DialogService, Confirmation } from '../../services';
import { fadeAnimation } from '../../animations/fade.animation';
import { slideUpAnimation } from '../../animations/slide-up.animation';

@Component({
  selector: 'hfc-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  animations: [fadeAnimation, slideUpAnimation]
})
export class DialogComponent {
  constructor(private dialogService: DialogService) {}

  public get confirmation(): Confirmation {
    return this.dialogService.confirmation;
  }

  public get isAcceptButtonLoading() {
    return this.dialogService.isAcceptButtonLoading;
  }

  public get noteValue(): string {
    return this.dialogService.noteValue;
  }

  public set noteValue(value: string) {
    this.dialogService.noteValue = value;
  }

  public onAcceptClicked() {
    this.dialogService.accept();
  }

  public onRejectClicked() {
    this.dialogService.reject();
  }

  public onSecondaryActionClicked() {
    this.confirmation.secondaryAction?.onClick();
    this.dialogService.accept();
  }
}
